export class VehicleTemplateDetailQueryParameters {
  headerId?: string;
  masterServiceFlag?: Boolean;
  oneTimeFlag?: Boolean;
  page?: number;
  pageSize?: number;
  serviceGroupId?: string;
  serviceTypeId?: string;
  sequence?: string;

  constructor(obj?: VehicleTemplateDetailQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
